export default "__VITE_ASSET__oYX4DEdu__"